import React, {Component} from 'react';

class ErpanalyticsItem extends Component {
    render(){
        let {analyticsImage, text} = this.props;
        return(
            <div className="col-md-4">
                <div className="erp_analytics_item text-center">
                    
                    <img src={require ("../img/Mss/" + analyticsImage)} alt=""/>   
                    <h3> 25 k</h3>
                    
                    
                    <p>{text}</p>
                </div>
            </div>
        )
    }
}
export default ErpanalyticsItem;